// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"a88e6b87","381":"f4ca09ab","552":"00d9d406","605":"fc3e8136","652":"e7ea8b50","678":"560ee6fd","920":"87003d58","932":"3a03592e"}[chunkId] + ".chunk.js";
};